// extracted by mini-css-extract-plugin
module.exports = {"container":"ZippsID_container__3GZ8k","spinner":"ZippsID_spinner__zVwFO","text":"ZippsID_text__1KThD"};